var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFuelTypeDiesel32 = function SvgFuelTypeDiesel32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.138 13.961a10.27 10.27 0 0 1 .85 10.344 10.1 10.1 0 0 1-3.51 4.038 9.884 9.884 0 0 1-10.224.441 10.063 10.063 0 0 1-3.836-3.72A10.254 10.254 0 0 1 6 19.876a10.255 10.255 0 0 1 1.398-5.193l.769-1.194L16.027 2l8.11 11.961Z",
    stroke: "currentColor",
    strokeWidth: 2.07,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 14 10 28m11-17L8 24M19 7 6 20m19-1L14 30",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
};
export default SvgFuelTypeDiesel32;